import { Header } from "../components/Header";
import React, { useState, useEffect } from "react";
import { TaskItem } from "./TaskItem";
import Pagination from "react-js-pagination";
import "react-loading-skeleton/dist/skeleton.css";
import { FilterData } from "../components/FilterData";
import {
  IMAGE_PATH,
  CLIENT_ID,
  CLIENT_SECRET,
  DATA_DECRYPTION_KEY,
  CDN_ELK_URL,
  BASE_URL_API
} from "../components/Constants";
import axios from "axios";
import crypto from "crypto-js";
import { decryptAES } from "../components/CryptoUtils";
import Skeleton, {SkeletonTheme} from 'react-loading-skeleton';

export const Contributionaltasklist = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [tasks, setTasks] = useState([]);
  const [sortValue, setSortValue] = useState("desc"); // Default value
  const limit = 10;
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedComplexityLevels, setSelectedComplexityLevels] = useState([]);
  const [selectedStatusLevel, setSelectedStatusLevel] = useState([]);
  const [selectedTechSkills, setSelectedTechSkills] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [accordionOpen, setAccordionOpen] = useState({});
  const [allRecords, setAllRecords] = useState([]);
  const [complexityCount, setComplexityCount] = useState([]);
  const [statusCount, setStatusCount] = useState([])
  //const [lastComplexityCount, setLastComplexityCount] = useState([]);
  const [filteredRecordsCount, setFilteredRecordsCount] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const labelMapping = {
    All: "All",
    Low: "Beginner",
    Medium: "Intermediate",
    High: "Advanced",
  };

  // const status = ['Active', 'Archived']

  const displayOrder = ["All", "Low", "Medium", "High"];


  useEffect(() => {
    setFilterData(FilterData);
    window.scrollTo(0, 0);
  }, []);

  const handleCheckboxChange = (filterType, subitem, itemId) => {
    if (filterType === "complexity") {
      setSelectedComplexityLevels((prevSelected) => {
        if (subitem === "All") {
          // If "All" is selected, either select all or deselect all
          if (prevSelected.includes("All")) {
            // Deselect all
            return [];
          } else {
            // Select all items in `complexityCount`
            return complexityCount.map((item) => item.label);
          }
        } else {
          // If an individual item is selected, update the list
          const newSelected = prevSelected.includes(subitem)
            ? prevSelected.filter((value) => value !== subitem)
            : [...prevSelected, subitem];
  
          // Check if all other categories are selected when selecting an individual item
          const allLabels = complexityCount.map((item) => item.label);
          const allSelected =
            newSelected.length === allLabels.length - 1 &&
            !newSelected.includes("All");
  
          // If all categories are selected, add "All"; otherwise, return updated list
          return allSelected ? ["All", ...newSelected] : newSelected.filter((item) => item !== "All");
        }
      });
    } else if (filterType === "techSkills") {
      setSelectedTechSkills((prevSelected) => {
        const newSelected = prevSelected.includes(subitem)
          ? prevSelected.filter((value) => value !== subitem)
          : [...prevSelected, subitem];

        // Check if any checkbox is selected for this accordion item
        const shouldOpen = newSelected.length > 0;
        setAccordionOpen((prev) => ({
          ...prev,
          [itemId]: shouldOpen,
        }));

        // Close accordion if no checkboxes are checked
        if (newSelected.length === 0) {
          setAccordionOpen((prev) => ({
            ...prev,
            [itemId]: true,
          }));
        }

        return newSelected;
      });
    } else if (filterType === "status"){
     
      setSelectedStatusLevel((prevSelected) => {
          // If an individual item is selected, update the list
          const newSelected = prevSelected.includes(subitem)
            ? prevSelected.filter((value) => value !== subitem) // Remove if already selected
            : [...prevSelected, subitem]; // Add if not selected
          return newSelected;
        });
    }
  };

  const handleKeyUp = (event) => {
    // Update the search query state with the current value of the input
    setSearchQuery(event.target.value.trim());
    setCurrentPage(1); // Reset to first page when sorting
  };

  const handleSort = (event) => {
    const selectedValue = event.target.value;
    setSortValue(selectedValue);
    setCurrentPage(1); // Reset to first page when sorting
  };
  const handleRemoveSkill = (skillToRemove) => {
    setSelectedTechSkills((prevSkills) =>
      prevSkills.filter((skill) => skill !== skillToRemove)
    );
  };

  const handleClearAll = () => {
    setSelectedTechSkills([]);
  };

  const parseSkills = (skillString) => {
    return skillString
      .match(/[^,(]+(?:\([^)]*\))?[^,]*/g)
      ?.map(item => item.trim())
      .filter(Boolean) || [];
  };
  
  function transformData(input) {

    const inputComplexity = {
      Medium: input.complexity_counts.Medium,
      High: input.complexity_counts.High,
      Low: input.complexity_counts.Low,
  };

    const statusVal  = {
      Active:input.total_active,
      Archieved:input.total_archived
    }

    const fetch_records = input.data.map((record) => ({
      artifact_id: record.artifact_id,
      real_name: record.real_name,
      submitted_on:record.submitted_on,
      tracker_id: record.tracker_id,
      user_name: record.user_name, 
      status : record.status,
      assign_to: {
        label: "Others",
        value: record.assign_to
          ? record.assign_to.split(",").map((item) => item.trim())
          : [], 
      },
      category: { label: "Category", value: [record.category] },
      complexity: { label: "Complexity Level", value: [record.complexity] },
      descriptions: { label: "Descriptions", value: [record.descriptions] },
      documents: { label: "Documents", value: [record.documents] },
      expected_outcome: { label: "Expected Outcome", value: [record.expected_outcome] },
      how_to_submit: { label: "How to Submit", value: [record.how_to_submit] },
      last_submission_date_1: { label: "Last Submission Date", value: [record.last_submission_date_1] },
      mentor_s_1: { label: "Others", value: [record.mentor_s_1] },
      mode_of_the_task: { label: "Others", value: [record.mode_of_the_task] },
      mode_of_the_task_1: { label: "Others", value: [record.mode_of_the_task_1] },
      product_name_1: { label: "Product Name", value: [record.product_name_1] },
      publisher_details: { label: "Publisher Details", value: [record.publisher_details] },
      reference_url: { label: "Reference URL", value: [record.reference_url] },
      repository_url: { label: "Repository URL", value: [record.repository_url] },
      skills_and_expertise:  {
        label: "Skills and Expertise",
        value: record.skills_and_expertise
          ? parseSkills(record.skills_and_expertise)
          : [], 
      },
      submitted_real_name: { label: "Others", value: [record.submitted_real_name] },
      submitted_user_name: { label: "Others", value: [record.submitted_user_name] },
      title: { label: "Title", value: [record.title] },
      what_you_ll_do: { label: "Others", value: [record.what_you_ll_do] },
    }));
  
    return {
      fetch_records,
      total_complexity : [
        { label: "All", label_count: inputComplexity.Medium + inputComplexity.High + inputComplexity.Low },
        { label: "Low", label_count: inputComplexity.Low },
        { label: "Medium", label_count: inputComplexity.Medium },
        { label: "High", label_count: inputComplexity.High }
    ],
      total_status: [
        {label:'Active', label_count:statusVal.Active},
        {label:'Archived', label_count:statusVal.Archieved}
    ],
      total_records: input.total_hits,
    };
  }

  useEffect(() => {
    const fetchRecords = async () => {
      try {
        setIsLoading(true);
        const newOffset = (currentPage - 1) * limit;

        const ts = Math.floor(Date.now() / 1000); // Get the current Unix timestamp

        const hmacStr =
          CLIENT_SECRET +
          CLIENT_ID +
          newOffset.toString() +
          limit.toString() +
          ts.toString();

        const hmacHash = crypto.SHA256(hmacStr).toString(crypto.enc.Hex);

        const formData = new FormData();
        formData.append("limit", limit);
        formData.append("offset", newOffset);
        formData.append("order_by", sortValue);
        
        let complexFilter = selectedComplexityLevels.filter(
          (level) => level !== "All" && level !== "N/A"
        );

        if ((complexFilter.length) === 3) {
          complexFilter = [];
        }

        const searchQueries = [searchQuery]; // You can add more queries if needed

        const advanceFilter = JSON.stringify({
          ...((searchQuery && searchQuery !== '') ? { title: searchQueries } : {}),
          ...((complexFilter && complexFilter.length > 0) ? { complexity: complexFilter } : {}),
          ...((selectedTechSkills && selectedTechSkills.length > 0) ? { skills_and_expertise: selectedTechSkills } : {}),
          ...((selectedStatusLevel && selectedStatusLevel.length>0) ? {status : selectedStatusLevel}: {})
        });

        formData.append('advance_filter', advanceFilter);
        formData.append("client_id", CLIENT_ID);
        formData.append("ts", ts);
        formData.append("hmac", hmacHash);

        // const result = await axios.post(
        //   `${BASE_URL_API}task/elk_listing`,
        //   formData
        // );
        const queryParams = {
          limit: limit,
          offset: newOffset,
          order_by: sortValue,
          advance_filter: advanceFilter,
          client_id: CLIENT_ID,
          ts: ts,
          hmac: hmacHash
        };

        const queryString = new URLSearchParams(queryParams).toString();

        // const result = await axios.get(`${BASE_URL_API}task/elk_caching?${queryString}`);

        const result = await axios.get(`${CDN_ELK_URL}/task/elk_caching?${queryString}`);
        

        if (result.data.code === 200) {
          setIsLoading(false);
          if (result.data.secure) {
            const encryptedData = await result.data.data;
            const decryptedText = await decryptAES(
              encryptedData,
              DATA_DECRYPTION_KEY
            );
            const flattenData = await JSON.parse(decryptedText); // Assuming decrypted data is JSON
            //console.log("output 201", output); 
            const output = transformData(flattenData)  
            setTasks(output.fetch_records);
            setAllRecords(output.fetch_records); // Store all records
            setTotalCount(output.total_records);
            if (output?.total_complexity !== undefined){
              //console.log(output.total_complexity);
              setComplexityCount(output.total_complexity);  
            } 
            if(output?.total_status !== undefined){
              setStatusCount(output.total_status)
            } 
          } else {
            setTasks(result.data.data.fetch_records);
            setAllRecords(result.data.data.fetch_records); // Store all records
            setTotalCount(result.data.data.total_records);
            if (result.data.data?.total_complexity !== undefined){
              setComplexityCount(result.data.data.total_complexity);  
            } 
          }
        } else {

          setTasks([]);
          setAllRecords([]);
          setTotalCount(0);
        }
      } catch (error) {
        console.error("There was a problem fetching the tasks:", error);
        
        setTasks([]);
        setAllRecords([]);
        setTotalCount(0);
      } finally{
        setIsLoading(false);
      }
    };

    fetchRecords();
  }, [
    currentPage, 
    limit, 
    sortValue, 
    searchQuery, 
    selectedTechSkills, 
    selectedStatusLevel,
    selectedComplexityLevels
  ]); // This effect runs only once when the component mounts

  // Update current page and trigger data fetching
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [activeTab, setActiveTab] = useState(null); // Set initial active tab to the first category
  const [searchTerm, setSearchTerm] = useState("");
  const [isComplexityTab, setIsComplexityTab] = useState(false);
  const [isStatusTab,setIsStatusTab] = useState(false);

  useEffect(() => {
    // Set the first filter category as active when the component mounts
    if (filterData.length > 0) {
      setActiveTab(filterData[0].id); // Set the first category as active
    }
  }, [filterData]);

  const handleTabClick = (id) => {
    setActiveTab(id);
    setSearchTerm(""); // Reset search term when switching tabs
    setIsComplexityTab(false);
    setIsStatusTab(false);
  };

  const handleComplexityTabClick = () => {
    setIsComplexityTab(true);
    setActiveTab(null); // Reset category tab
    setIsStatusTab(false);
  };

  const handleStatusTabClick  = () =>{
    setIsStatusTab(true)
    setActiveTab(null); // Reset category tab
    setIsComplexityTab(false)
  }

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleResetFilters = () => {
    setSelectedComplexityLevels([]);
    setSelectedStatusLevel([])
    setSelectedTechSkills([]);
    setTasks(allRecords); // Reset the tasks to the original list
    setFilteredRecordsCount(0); // Reset the filtered records count
  };

  return (
    <>
      <Header />
      <main id="contri_list">
        
          <section>
            <div className="container">
              <div className="row">
                <div className="filter_1a col-sm-7">
                  <div className="input-group mb-3" id="filter_1">
                    <span
                      className="input-group-text"
                      style={{
                        borderRadius: "5px 0px 0px 5px",
                        backgroundColor: "#ffff",
                      }}
                    >
                      <img src={`${IMAGE_PATH}/search.svg`} alt="search.svg" />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder=""
                      aria-label="Server"
                      onKeyUp={handleKeyUp}
                    />
                    {/* display only mobile view */}
                    <div className="filter_tags col-sm-12">
                      <div className="tags">
                        {selectedTechSkills.map((skill, index) => (
                          <span
                            className="badge alert"
                            role="alert"
                            key={index}
                          >
                            {skill}
                            <button
                              type="button"
                              className="btn-close"
                              aria-label="Close"
                              onClick={() => handleRemoveSkill(skill)}
                            ></button>
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="selected-skills-container d-flex align-items-center flex-wrap">
                    {selectedTechSkills.map((skill, index) => (
                      <div
                        key={index}
                        className="skill-pill d-flex align-items-center me-2 mb-2"
                      >
                        {skill}
                        <button
                          type="button"
                          className="remove-skill-btn ms-2"
                          onClick={() => handleRemoveSkill(skill)}
                          aria-label={`Remove ${skill}`}
                        >
                          &times; {/* Cross icon */}
                        </button>
                      </div>
                    ))}

                    {selectedTechSkills.length > 0 && (
                      <button
                        className="btn clear-all-btn ms-2"
                        onClick={handleClearAll}
                      >
                        Clear all
                      </button>
                    )}
                  </div>
                </div>
                <div className="col-sm-5" id="filter_2">
                  <div className="d-flex justify-content-end align-items-right">
                    <select
                      className="form-select w-auto"
                      onChange={handleSort}
                      value={sortValue}
                      aria-label="Sort tasks by date"
                    >
                      <option>Sort by:</option>
                      <option value="desc">Newest</option>
                      <option value="asc">Oldest</option>
                    </select>
                  </div>
                  <div className="task-available">
                    <p>{totalCount} tasks available</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3 mt-10">
                  <div className="filter-section" id="skills">
                    <h6>CATEGORY</h6>
                    <div className="accordion" id="skillsAccordion">
                      {filterData.map((item, index) => (
                        <div className="accordion-item" key={item.id}>
                          <h2
                            className="accordion-header"
                            id={`heading-${item.id}`}
                          >
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapse-${item.id}`}
                              aria-expanded="false"
                              aria-controls={`collapse-${item.id}`}
                            >
                              <img src={item.icon} alt="ico8" /> {item.category}
                            </button>
                          </h2>

                          <div
                            id={`collapse-${item.id}`}
                            className={`accordion-collapse collapse ${
                              accordionOpen[item.id] ? "show" : ""
                            }`} // Update here
                            aria-labelledby={`heading-${item.id}`}
                            data-bs-parent="#skillsAccordion"
                          >
                            <div className="accordion-body">
                              {item.subcategories.map((subitem, subindex) => (
                                <div
                                  className="form-check"
                                  key={`${item.id}-${subindex}`}
                                >
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value={subitem} // Ensure you pass the correct subitem value
                                    id={`checkbox-${item.id}-${subindex}`}
                                    checked={selectedTechSkills.includes(
                                      subitem
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(
                                        "techSkills",
                                        subitem,
                                        item.id
                                      )
                                    }
                                  />
                                  <label
                                    className="form-check-label list-group-item d-flex justify-content-between align-items-start"
                                    htmlFor={`checkbox-${item.id}-${subindex}`}
                                  >
                                    {subitem}{" "}
                                    <span className="badge rounded-pill float-end"></span>
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <br></br>
                    <div className="accordion" id="skillsAccordion">
                      <div className="accordion-item" id="compl_a1">
                        <h2
                          className="accordion-header"
                          id="collapseProgrammin2"
                        >
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseDevTools"
                            aria-expanded="true"
                            aria-controls="collapseDevTools"
                          >
                            <span>Complexity Level</span>
                          </button>
                        </h2>
                        <div
                          id="collapseDevTools"
                          className="accordion-collapse collapse show"
                          aria-labelledby="collapseProgrammin2"
                          data-bs-parent="#skillsAccordion"
                        >
                          <div className="accordion-body">
                            {complexityCount.length > 0
                              ? complexityCount
                                  .filter((complexity) =>
                                    displayOrder.includes(
                                      complexity.label.trim()
                                    )
                                  )
                                  .sort(
                                    (a, b) =>
                                      displayOrder.indexOf(a.label.trim()) -
                                      displayOrder.indexOf(b.label.trim())
                                  )
                                  .map((complexity, index) => (
                                    <div className="form-check" key={index}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value={complexity.label.trim()}
                                        id={complexity.label.trim()}
                                        checked={selectedComplexityLevels.includes(
                                          complexity.label.trim()
                                        )}
                                        onChange={() =>
                                          handleCheckboxChange(
                                            "complexity",
                                            complexity.label.trim()
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label list-group-item d-flex justify-content-between align-items-start"
                                        htmlFor={complexity.label.trim()}
                                      >
                                        {labelMapping[complexity.label.trim()]}
                                        <span className="badge rounded-pill float-end">
                                          {complexity.label_count}
                                        </span>
                                      </label>
                                    </div>
                                  ))
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <br></br>
                    <div className="accordion" id="skillsAccordion">
                      <div className="accordion-item" id="compl_a1">
                        <h2
                          className="accordion-header"
                          id="collapseProgrammin2"
                        >
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseStatus"
                            aria-expanded="true"
                            aria-controls="collapseDevTools"
                          >
                            <span>Status</span>
                          </button>
                        </h2>
                        <div
                          id="collapseStatus"
                          className="accordion-collapse collapse show"
                          aria-labelledby="collapseProgrammin2"
                          data-bs-parent="#skillsAccordion"
                        >
                          <div className="accordion-body">
                            {statusCount.length > 0
                              ? statusCount.map((status, index) => (
                                    <div className="form-check" key={index}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value={status.label.trim()}
                                        id={status.label.trim()}
                                        checked={selectedStatusLevel.includes(status.label.trim())}
                                        onChange={() =>
                                          handleCheckboxChange(
                                            "status",
                                            status.label.trim()
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label list-group-item d-flex justify-content-between align-items-start"
                                        htmlFor={status.label.trim()}
                                      >
                                        {status.label.trim()}
                                        <span className="badge rounded-pill float-end">
                                          {status.label_count}
                                        </span>
                                       
                                      </label>
                                    </div>
                                  ))
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <br></br>
                  </div>
                </div>
                {
                  isLoading
                  ?
                  <>
                      <div className="col-sm-9">
                          <SkeletonTheme baseColor="#ebebeb" highlightColor="#fff">
                              <div className="row">
                                  <Skeleton count={5} />
                                  <div className="d-flex align-items-center justify-content-center">
                                      <Skeleton className="p-2 m-2 shadow rounded-5" count={1} />
                                      <Skeleton className="p-2 m-2 shadow rounded-5" count={1} />
                                      <Skeleton className="p-2 m-2 shadow rounded-5" count={1} />
                                  </div>
                              </div>
                          </SkeletonTheme>
                      </div>
                  </>
                  :
                  <div className="col-sm-9">
                    {tasks.length > 0 ? (
                      tasks.map((task, index) => (
                        <TaskItem
                          key={index}
                          task={task}
                          IMAGE_PATH={IMAGE_PATH}
                          searchQuery={searchQuery}
                        />
                      ))
                    ) : (
                      <div className="no_task">
                        <img src={`${IMAGE_PATH}/not-found.gif`} alt="no-task" />
                        <p>No results found</p>
                      </div>
                    )}
                    {tasks.length > 0 ? (
                      <Pagination
                        activePage={currentPage}
                        itemsCountPerPage={limit}
                        totalItemsCount={totalCount}
                        pageRangeDisplayed={5}
                        onChange={handlePageChange}
                        itemClass="page-item"
                        linkClass="page-link"
                        innerClass="pagination"
                      />
                    ) : null}
                  </div>
                }
              </div>
            </div>
          </section>
      </main>
      <div className="fixed-bottom" id="filter_bottom">
        <ul>
          <li
            className="border-0"
            data-bs-toggle="modal"
            data-bs-target="#mobile_filter"
          >
            <img src="img/filter_bottom_mobile.png"  alt="filter_bottom_mobile.png"/>
            Filter {filteredRecordsCount !== null && <span>{filteredRecordsCount}</span>}
          </li>
          <li data-bs-toggle="modal" data-bs-target="#sort_by">
            <img src="img/swap_vert_1.png" alt="swap_vert_1.png"/>
            Sort
          </li>
        </ul>
      </div>
      <div className="modal fade" id="sort_by">
        <div className="modal-dialog modal-fullscreen">
          {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> */}
          <img
            src="img/sort_cancel.png"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            alt="sort_cancel.png"
          />
          <div className="modal-content">
            <ul className="list-group list-group-flush">
              <li className="list-group-item">SORT BY</li>
              {/* <li
                className="list-group-item"
                onClick={() => handleSort({ target: { value: "trending" } })}
              >
                Trending
              </li> */}
              <li
                className="list-group-item"
                onClick={() => handleSort({ target: { value: "desc" } })}
                data-bs-dismiss="modal"
              >
                Newest
              </li>
              <li
                className="list-group-item"
                onClick={() => handleSort({ target: { value: "asc" } })}
                data-bs-dismiss="modal"
              >
                Oldest
              </li>
              {/* <li className="list-group-item">Most popular</li> */}
            </ul>
          </div>
        </div>
      </div>
      <div className="modal fade" id="mobile_filter">
        <div className="modal-dialog modal-fullscreen modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title h4" id="exampleModalFullscreenLabel">
                Filters
              </h5>
              <h6>
                <img
                  src="img/reload_mobile_filter.png"
                  alt="reload"
                  onClick={handleResetFilters}
                />
                Reset
              </h6>
            </div>
            <div className="modal-body p-0">
              <div className="d-flex align-items-start">
                {/* Tabs (Categories) */}
                <div
                  className="nav flex-column nav-pills me-3"
                  id="v-pills-tab"
                  role="tablist"
                  aria-orientation="vertical"
                >
                  {filterData.map((item) => (
                    <button
                      key={item.id}
                      className={`nav-link text-start ${
                        activeTab === item.id ? "active" : ""
                      }`}
                      id={`v-pills-${item.id}-tab`}
                      data-bs-toggle="pill"
                      data-bs-target={`#v-pills-${item.id}`}
                      type="button"
                      role="tab"
                      aria-controls={`v-pills-${item.id}`}
                      aria-selected={activeTab === item.id}
                      onClick={() => handleTabClick(item.id)}
                    >
                      {item.category}
                    </button>
                  ))}
                  <button
                    className={`nav-link text-start ${
                      isComplexityTab ? "active" : ""
                    }`}
                    id="v-pills-complexity-tab"
                    type="button"
                    role="tab"
                    aria-controls="v-pills-complexity"
                    aria-selected={isComplexityTab}
                    onClick={handleComplexityTabClick}
                  >
                    Complexity Level
                  </button>
                  <button
                    className={`nav-link text-start ${
                      isStatusTab ? "active" : ""
                    }`}
                    id="v-pills-complexity-tab"
                    type="button"
                    role="tab"
                    aria-controls="v-pills-complexity"
                    aria-selected={isStatusTab}
                    onClick={handleStatusTabClick}
                  >
                    Status
                  </button>
                </div>

                {/* Content (Subcategories) */}
                <div
                  className="tab-content flex-grow-1"
                  id="v-pills-tabContent"
                >
                  {/* Render category sub-menu if a category tab is active */}
                  {activeTab &&
                    filterData.map((item) => (
                      <div
                        key={item.id}
                        className={`tab-pane fade ${
                          activeTab === item.id ? "show active" : ""
                        }`}
                        id={`v-pills-${item.id}`}
                        role="tabpanel"
                        aria-labelledby={`v-pills-${item.id}-tab`}
                      >
                        <div>
                          <input
                            type="text"
                            className="form-control mt-2 mb-2"
                            placeholder="Search"
                            value={searchTerm}
                            onChange={handleSearch}
                          />
                          {item.subcategories
                            .filter((subitem) =>
                              subitem
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase())
                            )
                            .map((subitem, subIndex) => (
                              <div className="form-check" key={subIndex}>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`check-${item.id}-${subIndex}`}
                                  name={subitem}
                                  value={subitem}
                                  checked={selectedTechSkills.includes(subitem)}
                                  onChange={() =>
                                    handleCheckboxChange(
                                      "techSkills",
                                      subitem,
                                      item.id
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`check-${item.id}-${subIndex}`}
                                >
                                  {subitem}
                                </label>
                              </div>
                            ))}
                        </div>
                      </div>
                    ))}

                  {/* Render complexity sub-menu if complexity tab is active */}
                  {isComplexityTab && (
                  <>
                    <input
                      type="text"
                      className="form-control mt-2 mb-2"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={handleSearch}
                    />

                    <div className="accordion-body">
                      {complexityCount.length > 0
                        ? complexityCount
                            .filter((complexity) =>
                              displayOrder.includes(complexity.label.trim())
                            )
                            .sort(
                              (a, b) =>
                                displayOrder.indexOf(a.label.trim()) -
                                displayOrder.indexOf(b.label.trim())
                            )
                            .map((complexity, index) => (
                              <div className="form-check" key={index}>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value={complexity.label.trim()}
                                  id={complexity.label.trim()}
                                  checked={selectedComplexityLevels.includes(
                                    complexity.label.trim()
                                  )}
                                  onChange={() =>
                                    handleCheckboxChange(
                                      "complexity",
                                      complexity.label.trim()
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label list-group-item d-flex justify-content-between align-items-start"
                                  htmlFor={complexity.label.trim()}
                                >
                                  {labelMapping[complexity.label.trim()]} {/* Label Mapping */}
                                  <span>
                                    {complexity.label_count} {/* Count */}
                                  </span>
                                </label>
                              </div>
                            ))
                        : ""}
                    </div>
                  </>
                    )}
                  {isStatusTab && (
                  <>
                    <input
                      type="text"
                      className="form-control mt-2 mb-2"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={handleSearch}
                    />

                    <div className="accordion-body">
                      {statusCount.length > 0
                          ? statusCount.map((status, index) => (
                            <div className="form-check" key={index}>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value={status.label.trim()}
                                id={status.label.trim()}
                                checked={selectedStatusLevel.includes(status.label.trim())}
                                onChange={() =>
                                  handleCheckboxChange(
                                    "status",
                                    status.label.trim()
                                      )
                                }
                              />
                                <label
                                  className="form-check-label list-group-item d-flex justify-content-between align-items-start"
                                  htmlFor={status.label.trim()}
                                >
                                  {status.label.trim()}
                                <span >
                                  {status.label_count}
                                </span>
                                       
                                </label>
                            </div>
                          ))
                        : ""}
                    </div>
                  </>
                  )}

                </div>
              </div>
            </div>
            <div className="modal-footer border-0 p-0">
              <div id="filter_bottom1">
                <ul>
                  <li className="border-0" data-bs-dismiss="modal">
                    Close
                  </li>
                  {/* <li onClick={handleApplyFilters} data-bs-dismiss="modal">
                    Apply
                  </li> */}
                  {" "}
                  {/* Apply Button */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
